import { useState, useEffect } from "react";
import log from "loglevel";

import classNames from "classnames";
import { FA } from "../../utils/font-awesome";

const Range = (props) => {
  return (
    <div className={classNames("control-range", props.className)}>
      <FA icon={props.icon} />
      <input
        type="range"
        min="0"
        max="100"
        defaultValue={props.amount}
        onChange={props.onChange}
      />
    </div>
  );
};

const Controls = (props) => {
  const [time, updateTime] = useState(props.controlData.time);
  const [date, updateDate] = useState(props.controlData.date);

  useEffect(() => {
    props.onChange({ time, date });
  }, [time, date]);

  return (
    <div className="controls-3d">
      <Range
        icon="sun"
        className="segment"
        amount={time * 100}
        onChange={(e) => {
          updateTime(e.currentTarget.value / 100);
        }}
      />
      <Range
        icon="calendar"
        className="segment"
        amount={date * 100}
        onChange={(e) => {
          updateDate(e.currentTarget.value / 100);
        }}
      />
    </div>
  );
};

export default Controls;
